import React from "react"
import '../../sass/footer.scss';

const Footer = () => {
    return (
        <footer className="footer">
			<div className="footer_box">
				<p className="footer_text">Designed by Elodie Rondet, all rights reserved ©</p>
			</div>
		</footer>
    )
}

export default Footer;